import { MFEProvider } from '@redislabsdev/cloud-ui-mfe-context';
import { ReactNode } from 'react';
import { useTheme } from 'styled-components/macro';

const MFEsProvider = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();

  return <MFEProvider value={{ themeName: theme?.name }}>{children}</MFEProvider>;
};

export default MFEsProvider;
